<template>
  <div>
    <dialog-box v-if="showINRDialog" dialogWidth="640px" @close="cancelDialog">
      <div v-if="!confirmEnableINR" class="dialog-content">
        <div class="button-container mt-4">
          <div class="d-flex flex-column justify-content-center">
            <div class="button-title">
              {{
                $t(
                  'dashboard.secondAlternateConversionRateDetailsWidget.confirmationTitle'
                )
              }}
            </div>
            <p class="button-subtitle">
              {{ $t('dashboard.enableDripSwitchModal.description') }}
            </p>
            <div class="d-flex justify-content-center">
              <action-button
                variant="solid"
                class="mr-3"
                :click="enableDripSwitchUniversalStatus"
              >
                <b-icon-arrow-repeat
                  v-if="isAPIFullFilled"
                  animation="spin"
                  class="mr-2 color-white"
                />
                {{
                  $t(
                    'dashboard.secondAlternateConversionRateDetailsWidget.yesEnableButtonText'
                  )
                }}
              </action-button>
              <action-button variant="outline" :click="cancelDialog">
                {{
                  $t(
                    'dashboard.secondAlternateConversionRateDetailsWidget.cancel'
                  )
                }}
              </action-button>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="inr-enabled-dialog-content">
        {{ stopLottie() }}
        <lottie-player
          :src="fetchLottieJSON"
          background="transparent"
          speed="1"
          style="width: 100%; height: 110px"
          :loop="lottieLoop"
          class="mb-2"
          autoplay
        ></lottie-player>
        <div class="header">
          {{ $t('dashboard.congratulationText.title') }}
        </div>
        <div class="sub-header">
          {{ $t('dashboard.congratulationText.subtitle.prepend') }}
        </div>
        <div class="para">
          {{ $t('dashboard.congratulationText.subtitle.append') }}
        </div>
        <div class="d-flex justify-content-center">
          <div class="drip-text-button" @click="closeDialog">
            {{ $t('dashboard.congratulationText.gotItText') }}
            <b-icon-check class="wealthy-green-color ml-2" scale="1.4" />
          </div>
        </div>
      </div>
    </dialog-box>
  </div>
</template>
<script>
import invoiceService from '@/services/invoice'
import DialogBox from '@/components/common/DialogBox'
import ActionButton from '@/components/common/ActionButton'
import Confetti from '@/assets/images/lottie/confetti.json'

export default {
  components: { DialogBox, ActionButton },
  props: ['showINRDialog', 'isINREnabled'],
  data() {
    return {
      confirmEnableINR: false,
      lottieLoop: true,
      lottieJSON: Confetti,
      isAPIFullFilled: false
    }
  },
  computed: {
    fetchLottieJSON() {
      return JSON.stringify(this.lottieJSON)
    }
  },
  methods: {
    stopLottie() {
      if (this.confirmEnableINR) {
        setTimeout(() => {
          this.lottieLoop = false
        }, 4000)
      }
    },
    closeDialog() {
      this.confirmEnableINR = false
      this.$emit('closeDialog')
    },
    cancelDialog() {
      this.confirmEnableINR = false
      this.$emit('cancelDialog')
    },
    enableDripSwitchUniversalStatus() {
      this.isAPIFullFilled = true
      this.$mpTrack(`Enable 'User' INR Confirmation`)
      invoiceService
        .updateRemittanceStatus({
          user_id: this.$store.state.account.accountId,
          enabled: true
        })
        .then(({ status }) => {
          this.isAPIFullFilled = false
          if (status === 200) {
            this.confirmEnableINR = true
          } else {
            this.$notify({
              title: this.$t('notifications.somethingWrong.title'),
              text: this.$t('notifications.somethingWrong.text'),
              type: 'error'
            })
          }
        })
        .catch(() => {
          this.isAPIFullFilled = false
          return this.$notify({
            title: this.$t('notifications.somethingWrong.title'),
            text: this.$t('notifications.somethingWrong.text'),
            type: 'error'
          })
        })
    }
  }
}
</script>
<style lang="scss" scoped>
.dialog-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  .dialog-inner-container {
    background: $sky-blue-50;
    border-radius: 8px;
    .header {
      font-weight: 700;
      font-size: 36px;
      line-height: 42px;
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;
      color: $noble-blue-500;
      margin-top: 32px;
      margin-bottom: 12px;
    }
    .sub-header {
      font-weight: 700;
      font-size: 24px;
      line-height: 28px;
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;
      color: $black;
      margin-bottom: 32px;
    }
  }
  .button-container {
    display: flex;
    justify-content: center;
    .button-title {
      font-weight: 700;
      font-size: 24px;
      line-height: 28px;
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      color: $noble-blue-500;
      margin-bottom: 16px;
    }
    .button-subtitle {
      font-weight: 400;
      font-size: 16px;
      line-height: 19px;
      margin-bottom: 32px;
      justify-content: center;
      text-align: center;
      color: $black;
    }
  }
}
.inr-enabled-dialog-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  img {
    object-fit: cover;
    height: 110px;
    width: 460px;
    margin: auto;
  }
  .header {
    font-weight: 700;
    font-size: 24px;
    line-height: 28px;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    color: $noble-blue-500;
    margin-top: 24px;
    margin-bottom: 16px;
  }
  .sub-header {
    font-weight: 700;
    font-size: 16px;
    line-height: 28px;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    color: $black;
  }
  .para {
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 19px;
    text-align: center;
    justify-content: center;
    color: $black;
    margin-bottom: 24px;
  }
}
</style>
